/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService, TimeService, UNPLACEHOLDER } from '@dm/core';
import { type SelectOption } from '@dm/core/types';
import { MO } from 'app/common/constants';

@Injectable({ providedIn: 'any' })
export class SpecifyStrService {
    table = {
        createBtn: this.get('common.create_button'),
        previousBtn: this.get('common.previous_button'),
        nextBtn: this.get('common.next_button'),
        okBtn: this.get('common.confirm_button'),
        selectVstoreFirst: this.get('service.share_term_create_chooseVstore_tip'),
        noData: this.get('common.result_nodata_tip'),
    };
    title = {
        name: this.get('common.name_column'),
        id: this.get('common.ID_column'),
        capacity: this.get('common.capacity_column'),
        wwn: this.get('common.device_WWN_label'),
        description: this.get('common.description_column'),
        lun: this.get('common.lun_title'),
        pg: this.get('protection.protectionGroups_title'),
        fs: this.get('common.fileSystem_title'),
        lunType: this.get('common.objectType_LUN'),
        pgType: this.get('common.objectType_PG'),
        fsType: this.get('common.Filesystem_checkbox'),
        leftPgTitle: this.getAvailableTitle(this.get('protection.protectionGroups_title')),
        rightPgTitle: this.get('common.common_selected_label'),
        leftLunTitle: this.getAvailableTitle(this.get('common.LUNs')),
        rightLunTitle: this.get('common.common_selected_label'),
        leftFsTitle: this.get('protection.HyperCDPSchedule_task_create_step1_availFS_lab'),
        rightFsTitle: this.get('protection.HyperCDPSchedule_task_create_step1_selectedFS_lab'),
        type: this.get('common.type_column'),
        vStoreLab: this.get('common.owningVstore_lab'),
    };
    typeOpt: SelectOption[] = [
        {
            label: this.title.pgType,
            value: MO.PROTECT_GROUP,
        },
        {
            label: this.title.lunType,
            value: MO.LUN,
        },
    ];
    objectNotEnoughErr = this.get('common.selectOneObject_lab');

    getAvailableTitle(type: string): string {
        return this.get('common.available', [`${type}`]);
    }

    getSelectedTitle(type): string {
        return this.get('common.selected', [`${type}`]);
    }

    nullErrMsg(name: string): string {
        const i18nName = this.title[name];
        return this.get('common.null_validation', [i18nName]);
    }

    lengthErrMsg(min: number, max: number): string {
        return this.get('common.length_msg', [min, max]);
    }

    nameErrMsg(name: string): string {
        const i18nName = this.title[name];
        return this.get('common.nameformat_validation', [i18nName]);
    }

    constructor(
        private i18nService: I18nService,
        private time: TimeService,
    ) { }

    get(key: string, params?: any[] | boolean, colon?: boolean): string {
        return this.i18nService.get(key, params, colon);
    }

    renderTime(time: number): string {
        return time === 0 ?
            UNPLACEHOLDER :
            this.time.formatUTC(time * 1e3);
    }
}
